module.exports = __webpack_public_path__ + "static/img/4.77e7cf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/4.png
// module id = poKz
// module chunks = 44